export default {
  setLoading (state, status) {
    state.recoveriesLoading = status
  },
  setAdvanceRecoveries (state, advanceRecoveries) {
    state.advanceRecoveries = advanceRecoveries
  }
}
